/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var moyaToggle = MoyaContainer.get('core.toggle');
    MoyaComponents.register('site.division', function (el) {
        moyaToggle.create(el.querySelector('button'), el.querySelector('.languages'), 'division', {
            closeOthers: true,
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
